package pwgs.ui.scenes.generalsettingsscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class AGeneralSettingsControllerFe(props: pwgs.ui.scenes.generalsettingsscene.GeneralSettingsSceneProps, scene: MGeneralSettingsScene)
 : AController<pwgs.ui.scenes.generalsettingsscene.GeneralSettingsSceneProps, pwgs.ui.scenes.generalsettingsscene.GeneralSettingsSceneModel, GeneralSettingsSceneState>(props, scene) {

    val backend = GeneralSettingsControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class GeneralSettingsControllerBeProxy(private val controller: AGeneralSettingsControllerFe) {

    suspend fun load(): pwgs.ui.scenes.generalsettingsscene.GeneralSettingsSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.generalsettingsscene.GeneralSettingsControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.generalsettingsscene.GeneralSettingsSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.generalsettingsscene.GeneralSettingsSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.generalsettingsscene.GeneralSettingsSceneModel.serializer())
        }
    }

}
